<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card style="min-width: 550px" class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6 text-center" id="title-card-authorization">
            {{ title }}
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <slot name="body"></slot>
        </q-card-section>

        <q-card-actions align="center" class="text-primary container-actions">
          <q-btn
            v-if="showBottonCancel"
            class='bCancel'
            flat
            label="Cancelar"
            v-close-popup
            @click="cancel()"
          />
          <q-btn
            :data-cy="dataCy"
            :label="labelSuccess"
            class="bPrincipal"
            padding="xs lg"
            @click="create()"
            :loading="isLoading"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog } from 'quasar';
export default {
  components: {
    QDialog
  },
  props: {
    value: {
      required: true
    },
    title: {
      required: false,
      type: String,
      default: () => ''
    },
    labelSuccess: {
      required: false,
      type: String,
      default: () => 'Aceptar'
    },
    dataCy: {
      required: false,
      type: String,
      default: () => ''
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: () => false
    },
    showBottonCancel: {
      required: false,
      type: Boolean,
      default: () => true
    }
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    },
    create () {
      this.$emit('save');
    }
  },
  data () {
    return {
      valueLocal: this.value
    };
  },
  watch: {
    value: {
      handler: function () {
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.card-authorization {
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $azulcabecera;
    }
  }
  .container-actions{
    padding-top: 15px;
  }
  .container-auth {
    padding-top: 20px;
    padding-bottom: 25px;
    .title-option {
      font-family: DINPro;
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #5c5c5c;
      padding-bottom: 20px;
    }
  }
    &::v-deep {
      .q-field--standard .q-field__control:before {
        border-bottom-color: rgba(89, 89, 89, 0.5) !important;
      }
    }
}
.q-dialog__inner {
  div::v-deep {
    border-radius: 12px !important;
  }
}
</style>
